import { render, staticRenderFns } from "./DragAndDropUpload.vue?vue&type=template&id=2007da4c&"
import script from "./DragAndDropUpload.vue?vue&type=script&lang=js&"
export * from "./DragAndDropUpload.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDropUpload.vue?vue&type=style&index=0&id=2007da4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports